module.exports = __webpack_public_path__ + "media/public/fonts/QanelasSemiBold/QanelasSemiBold-d1446d625f7648b54cf895387836a473.woff";